const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1075"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2225"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M33.313 41H7.688A7.687 7.687 0 0 1 0 33.313V7.688A7.687 7.687 0 0 1 7.688 0h25.625A7.687 7.687 0 0 1 41 7.688v25.625A7.687 7.687 0 0 1 33.313 41zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5106",
    d: "M10.574 98.725c-4.04 0-7.7 2.211-10.408 5.8a.837.837 0 0 0 0 1c2.7 3.595 6.368 5.805 10.408 5.805s7.7-2.211 10.408-5.8a.837.837 0 0 0 0-1c-2.704-3.594-6.368-5.805-10.408-5.805zm.29 10.741a4.448 4.448 0 1 1 4.149-4.149 4.45 4.45 0 0 1-4.15 4.149zm-.134-2.05a2.395 2.395 0 1 1 2.236-2.236 2.391 2.391 0 0 1-2.237 2.236z",
    transform: "translate(10.427 -84.028)",
    style: {
      fill: "#faa100"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.912ee34621ec89f6c9236f6ed25b2cfb.svg";
export { ForwardRef as ReactComponent };